// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f69c718","732":"c0402ca3","977":"3b59e814"}[chunkId] + ".chunk.js";
};